import { createApp } from "vue";
import { createPinia } from "pinia";
import Toast from "vue-toastification";

import App from "./App.vue";
import router from "./router";
import "./style.css";
import "vue-toastification/dist/index.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import { useBrandingStore } from "./stores/branding";

const bootstrap = async () => {
  const app = createApp(App);

  const pinia = createPinia();
  app.use(pinia);

  const brandingStore = useBrandingStore(pinia);
  await brandingStore.loadBranding();

  app.use(router);

  app.use(Toast, {
    transition: "Vue-Toastification__bounce",
    maxToasts: 20,
    newestOnTop: true,
    position: "top-right",
    timeout: 5000,
    closeOnClick: true,
    pauseOnFocusLoss: true,
    pauseOnHover: true,
    draggable: true,
    draggablePercent: 0.6,
    showCloseButtonOnHover: false,
    hideProgressBar: false,
    closeButton: "button",
    icon: true,
    rtl: false,
  });

  app.mount("#app");
};

bootstrap();
